import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelEmoji } from '../../../../../modules/RavelEmoji.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';

export class RavelCrank extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
            cursor: pointer;
            user-select: none;
        }
        #crank-marker, #crank-knob {
            position: relative;
        }
        #sensor {
            position: absolute;
            left: -10%;
            top: -10%;
            width: 120%;
            height: 120%;
            border-radius: 50%;
            
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="sensor"></div>
        <div id="crank-knob"></div>
        <div id="crank-marker"></div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'size', 'w', 'h', 'use-svg', 'color',
            'marker', 'icon', 'marker', 'angle', 'min', 'max',
            'value', 'signals', 'signal-out'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.potMarker = this.shadowRoot.querySelector('#crank-marker');
        this.potKnob = this.shadowRoot.querySelector('#crank-knob');
        this.sensor = this.shadowRoot.querySelector('#sensor');
        this.marker = '';
        this.icon = 'white-circle';
        this.size = 24;
        this.signals = [];
        this.value = 0;
        this.noClick = false;
        this.showFeedback = false;
        this.x = 0;
        this.y = 0;
        this.width = 50;
        this.height = 50;
        this.min = 0;
        this.max = 1;
        this.offsetX = 0;
        this.offsetY = 0;
        this.useSvg = false;
        this.lastAngle = null;
        this.lastTimestamp = null;
        this.velocitySamples = [];
    }
  
    setup = () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.subscribe(this.signals);  
        //this.potKnob.textContent = RavelEmoji.getRandomRoundEmoji();
        //this.potMarker .textContent = RavelEmoji['white-circle']; // 
        // x, y are the center point

        this.container.style.top = `${this.y}px`;
        this.container.style.left = `${this.x}px`;
        this.container.style['width'] = `${this.width}px`;
        this.container.style['height'] = `${this.height}px`;
        this.container.style['font-size'] = `${this.width}px`;
        this.container.style['font-size'] = `${this.width}px`;
        this.potKnob.textContent = RavelEmoji[this.icon];
        this.potMarker.textContent = RavelEmoji[this.marker]; // 
        this.potMarker.style['font-size'] = `${this.width / 5}px`;
        this.potMarker.style['top'] = `-${this.width - this.width / 16}px`;
        this.potMarker.style['left'] = `${- this.width /  4 }px`;
        this.potKnob.style['line-height'] = `-${this.width + 10}px`;
        this.container.style["transform"] = "rotate(" + this.angle + "deg)";
        
        if (this.useSvg) {
            this.shadowRoot.querySelector('#crank-knob').innerHTML = this.potSvg;
            this.shadowRoot.querySelector('#crank-knob-svg').style.width = `${this.width}px`;
            this.shadowRoot.querySelector('#crank-knob-svg').style.height = `${this.height}px`;
            this.shadowRoot.querySelector('#crank-knob-svg').querySelector('#circle').style.fill = `${this.color}`;
        }
        //this.potKnob.style['top'] = `-${this.size / 8}px`;
        this.potMarker.style['opacity'] = `0.75`;
        const rect = this.container.getBoundingClientRect();
        this.centerX = rect.left + rect.width / 2;
        this.centerY = rect.top + rect.height / 2;
        if (!this.noClick) {
            this.addEventListener('pointerdown', this.handleClick);
        }
        this.addEventListener(`${this.id}`, this.handleEvent);
        this.broadcastMessage('register-sensor', this.id, this.container);
        //this.broadcastMessage('register-sensor', this.id, { x: this.x + this.w/2, y: this.y + this.h/2, w: this.w, h: this.height });
    }

    handleClick = (e) => {
        e.preventDefault();
        // Update center values dynamically in case layout shifted
        const rect = this.container.getBoundingClientRect();
        this.centerX = rect.left + rect.width / 2;
        this.centerY = rect.top + rect.height / 2;
        this.calculateCrankAngle(e.clientX, e.clientY);
        document.addEventListener('pointermove', this.dragElement);
        document.addEventListener('pointerup', this.endDragElement);
        document.addEventListener('pointerleave', this.endDragElement);
    }

    dragElement = (e) => {
        e.preventDefault();
        this.calculateCrankAngle(e.clientX + this.offsetX, e.clientY + this.offsetY);
    }

    endDragElement = () => {
        document.removeEventListener('pointermove', this.dragElement);
        document.removeEventListener('pointerup', this.endDragElement);
        document.removeEventListener('pointerleave', this.endDragElement);
    }

    handleEvent = (e) => {
        e.preventDefault();
        const type = e.detail.cmd;
        console.log(type);
        if (type === 'select') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 0, 0.5)';
        }
        if (type === 'unselect') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 255, 0)';
        }
        if (type === 'virtual-click') {
            let x = e.detail.content.startX;
            let y = e.detail.content.startY;
            this.offsetX = Number(e.detail.content.offsetX);
            this.offsetY = Number(e.detail.content.offsetY);
            const rect = this.container.getBoundingClientRect();
            this.centerX = (rect.left + rect.width / 2);
            this.centerY = (rect.top + rect.height / 2);
            this.calculateCrankAngle(x + this.offsetX, y + this.offsetY);
            document.addEventListener('pointermove', this.dragElement);
            document.addEventListener('pointerup', this.endDragElement);
            document.addEventListener('pointerleave', this.endDragElement);
            console.log(this.offsetX + " " + this.offsetY);
        }
        if (type === 'virtual-drag') {
            this.calculateCrankAngle(e.clientX, e.clientY);
        }
        if (type === 'virtual-release') {
            this.offsetX = 0;
            this.offsetY = 0;
            document.removeEventListener('pointermove', this.dragElement);
            document.removeEventListener('pointerup', this.endDragElement);
            document.removeEventListener('pointerleave', this.endDragElement);
        }
    }

    
    teardown = () => {
        this.unsubscribe(this.signals);
        this.broadcastMessage('register-sensor', this.id);
        if (!this.noClick) {
            this.removeEventListener('pointerdown', this.handleClick);
        }
        this.removeEventListener(`${this.id}`, this.handleEvent);
    }
    
    calculateCrankAngle = (x, y) => {

    	let d1 = y - this.centerY;
    	let d2 = x - this.centerX;

        this.angle = Math.atan2(d1, d2) * (180 / Math.PI) - 180;
        this.container.style["transform"] = "rotate(" + this.angle + "deg)";
       
        const now = performance.now();

        if (this.lastAngle !== null && this.lastTimestamp !== null) {
            // Step 1: Remap angles so 180° is the logical zero
            const logicalNow = (this.angle + 180) % 360;
            const logicalLast = (this.lastAngle + 180) % 360;

            // Step 2: Normalize difference to range [-180, 180]
            let deltaAngle = ((logicalNow - logicalLast + 540) % 360) - 180;
            // ↑ Adding 540 (not 180) prevents negative mod issues

            // Step 3: Calculate angular velocity
            const deltaTime = (now - this.lastTimestamp) / 1000; // seconds
            this.angularVelocity = deltaAngle / deltaTime;

            // Step 4: Smooth it 
            this.velocitySamples.push(this.angularVelocity);
            if (this.velocitySamples.length > 5) this.velocitySamples.shift();
            this.angularVelocity = (this.velocitySamples.reduce((a, b) => a + b, 0) / this.velocitySamples.length) / 1000;
            if (this.angularVelocity > 1) this.angularVelocity = 1;
            if (this.angularVelocity < -1) this.angularVelocity = -1;
            console.log('Angular Velocity:', this.angularVelocity.toFixed(2));
        }

        this.lastAngle = this.angle;
        this.lastTimestamp = now;

        this.sendMessage(this.signalOut, this.id, this.angularVelocity);
     
        /*
        if (this.angle <= 210) {
            this.value = this.map(this.angle, 0, 210, 0.3, 1);
        } else {
            this.value = this.map(this.angle, 305, 360, 0, .3);
        }
        */
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'size') {
            this.size = Number(newValue);
        }
        if (name === 'x') {
            this.container.style.position = 'absolute';
            this.x = Number(newValue);
        }
        if (name === 'y') {
            this.container.style.position = 'absolute';
            this.y = Number(newValue);
        }
        if (name === 'use-svg') {
            this.useSvg = true;
        }
        if (name === 'w') {
            this.width = Number(newValue);
        }
        if (name === 'h') {
            this.height = Number(newValue);
        }
        if (name === 'color') {
            this.color = newValue;
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'icon') {
            this.icon = newValue;
        }
        if (name === 'marker') {
            this.marker = newValue;
        }
        if (name === 'angle') {
            this.angle = Number(newValue);
        }
        if (name === 'value') {
            this.value = Number(newValue);
        }
        if (name === 'signals') {
            this.signals = newValue.split(',');
        }
        if (name === 'signal-out') {
            this.signalOut = newValue;
        }
        if (name === 'no-click') {
            this.noClick = true;
        }
        if (name === 'show-feedback') {
            this.showFeedback = true;
        }
    }

    map = (val, in_min, in_max, out_min, out_max) => {
        return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    }

    potSvg = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="crank-knob-svg"
   width="267.03113"
   height="257.45898"
   viewBox="0 0 267.03113 257.45898"
   sodipodi:docname="crank-1.svg"
   inkscape:version="1.3.2 (091e20e, 2023-11-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs1" />
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="0.61458334"
     inkscape:cx="21.152542"
     inkscape:cy="136.67796"
     inkscape:window-width="1336"
     inkscape:window-height="841"
     inkscape:window-x="0"
     inkscape:window-y="38"
     inkscape:window-maximized="0"
     inkscape:current-layer="g1"
     showguides="false" />
  <g
     inkscape:groupmode="layer"
     inkscape:label="Image"
     id="g1"
     transform="translate(-1052.7501,459.03516)">
    <path
       id="rect70"
       style="fill:#000000;fill-opacity:0.5;stroke:none;stroke-width:1.64482"
       d="M 1146.9317 -459.03516 L 1146.9317 -417.36914 L 1107.1778 -417.36914 L 1107.1778 -374.47071 L 1107.1778 -373.98438 A 43.728813 43.728813 0 0 0 1105.8341 -374.01758 A 43.728813 43.728813 0 0 0 1062.1056 -330.28907 A 43.728813 43.728813 0 0 0 1105.8341 -286.56055 A 43.728813 43.728813 0 0 0 1107.1778 -286.65625 L 1107.1778 -286.18555 L 1107.1778 -243.24219 L 1146.9317 -243.24219 L 1146.9317 -201.57618 L 1235.17 -201.57618 L 1235.17 -243.24219 L 1274.9239 -243.24219 L 1274.9239 -286.18555 L 1319.7813 -286.18555 L 1319.7813 -374.42383 L 1274.9239 -374.42383 L 1274.9239 -417.36914 L 1235.17 -417.36914 L 1235.17 -459.03516 L 1146.9317 -459.03516 z " />
    <path
       id="circle"
       style="fill:#ff6600;fill-opacity:1;stroke:none;stroke-width:1.33333"
       d="M 1191.0509 -411.66211 A 81.355934 81.355934 0 0 0 1120.3595 -369.99805 A 44.296047 44.296047 0 0 1 1146.5196 -329.59961 A 44.296047 44.296047 0 0 1 1120.9435 -289.47852 A 81.355934 81.355934 0 0 0 1191.0509 -248.94922 A 81.355934 81.355934 0 0 0 1272.4063 -330.30469 A 81.355934 81.355934 0 0 0 1191.0509 -411.66211 z " />
    <circle
       style="fill:#000000;stroke-width:1.03294;stroke-linecap:round;stroke-linejoin:round"
       id="path1"
       cx="1104.3418"
       cy="-329.27618"
       r="30.602644" />
  </g>
</svg>
`;
}

